import baseScmService from 'services/baseScmService';

const capstoneSubmissionService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    getCapstoneSubmissions: build.query({
      query: ({ type, page }) => ({
        url: '/capstone-submissions',
        params: {
          type,
          page,
        },
      }),
      providesTags: (result, error) => {
        if (error) return [];
        if (result?.data?.length > 0) {
          const submissions = result.data;

          return submissions.map((submission) => ({
            type: 'CapstoneSubmission',
            id: submission.id,
          }));
        }
        return [];
      },
    }),
    updateCapstoneSubmissionStatus: build.mutation({
      query: ({ submissionId, reason, status }) => ({
        method: 'PUT',
        url: `/capstone-submissions/${submissionId}`,
        body: { reason, status },
      }),
      invalidatesTags: (result, error, { submissionId }) =>
        error ? [] : [{ type: 'CapstoneSubmission', id: submissionId }],
    }),
    syncUserActivities: build.mutation({
      query: ({ learnerEmail, academyModule }) => ({
        method: 'POST',
        url: `/academic-activities/sync-user-activities`,
        body: {
          email: learnerEmail,
          academy_module_id: academyModule?.value,
        },
      }),
      invalidatesTags: (result, error) =>
        error ? [] : [{ type: 'CapstoneSubmission' }],
    }),
  }),
});

export const {
  useGetCapstoneSubmissionsQuery,
  useUpdateCapstoneSubmissionStatusMutation,
  useSyncUserActivitiesMutation,
} = capstoneSubmissionService;

export default capstoneSubmissionService;
